module.exports = __webpack_public_path__ + "static/media/ruhtinas-blue-bg-gold-400x240.4ea5aa39.png";